import EmptyList from 'modules/core/components/EmptyList'
import { Table } from 'modules/core/components/Table'
import type { WithMultiSelectStateChildrenProps } from 'modules/core/components/WithMultiSelectState'
import i18n from 'modules/core/lib/i18n'

import Content from '../Content'
import type { ImportedContract } from '../Content/types'

type WithMultiSelectProps = WithMultiSelectStateChildrenProps<ImportedContract>

interface Props {
  contracts: ImportedContract[]
  selected: ImportedContract[]
  attributes: string[]
  customFields: string[]
  onToggleSelectedItem: WithMultiSelectProps['onToggleSelectedItem']
  onDeselectAll: () => void
  onSelectAll: () => void
  tabId: string
}

const ContractsTable = ({
  contracts,
  selected,
  attributes,
  customFields,
  onToggleSelectedItem,
  onDeselectAll,
  onSelectAll,
  tabId,
}: Props) => {
  if (contracts.length === 0) {
    let description

    if (tabId === 'ready') {
      description = i18n.t('import_contract.blank_slate.ready')
    } else {
      description = i18n.t('import_contract.blank_slate.errored')
    }

    return <EmptyList description={description} squared />
  }

  return (
    <Table withTabs withHeight>
      <Content
        contracts={contracts}
        selected={selected}
        attributes={attributes}
        customFields={customFields}
        onToggleSelectedItem={onToggleSelectedItem}
        onDeselectAll={onDeselectAll}
        onSelectAll={onSelectAll}
      />
    </Table>
  )
}

export default ContractsTable
